import { PEPTIDE_LINKS } from "@/config/peptide-links";

/**
 * Resolves a research-peptide reference slug to its live Saleor product path.
 *
 * Strategy: `src/config/peptide-links.ts` is the authoritative allow-list of
 * active Saleor products. If a reference-peptide slug has a `productSlug`
 * entry there, the product is live and we derive its path. Otherwise we return
 * `null` (pipeline / restricted / no active product yet).
 *
 * We do NOT maintain a separate full SALEOR_PRODUCT_MAP constant because
 * `PEPTIDE_LINKS` already captures the live-product allow-list; duplicating it
 * would create a second source of truth that drifts when products are added.
 *
 * Slug-normalisation note: the Stack-Builder uses legacy aliases like `tb500`
 * and `mt-2` whose `productSlug` in PEPTIDE_LINKS is the canonical Saleor slug
 * (e.g. `tb-500`). Reference-peptide slugs in `peptides-reference.ts` use the
 * canonical Saleor slug directly, so a direct PEPTIDE_LINKS lookup is correct.
 */
export function getProductPathForPeptide(slug: string): string | null {
	const entry = PEPTIDE_LINKS[slug];
	if (!entry) return null;
	return `/products/${entry.productSlug}`;
}
